export const CDN_ASSETS = {
  capone: {
    searchLoading: {
      flights:
        "https://cdn.hoppercot.com/capone/search-loading/flights-search-loading.jpg",
      hotels:
        "https://cdn.hoppercot.com/capone/search-loading/hotels-search-loading.jpg",
      cars: "https://cdn.hoppercot.com/capone/search-loading/cars-search-loading.jpeg",
      premiumStays:
        "https://cdn.hoppercot.com/capone/search-loading/premium-stays-search-loading.jpg",
      lifestyleCollection:
        "https://cdn.hoppercot.com/capone/search-loading/lifestyle-collection-search-loading.jpg",
      premierCollection:
        "https://cdn.hoppercot.com/capone/search-loading/premier-collection-search-loading.jpg",
      experiences:
        "https://cdn.hoppercot.com/capone/search-loading/experiences-search-loading.jpg",
    },
    loaders: {
      chat: "https://cdn.hoppercot.com/capone/loaders/chat_loader.gif",
      runningBunny: "https://cdn.hoppercot.com/capone/loaders/running_bunny.gif",
      runningBunnyWhite:
        "https://cdn.hoppercot.com/capone/loaders/running_bunny_white.gif",
    },
    pageBanner: {
      desktop:
        "https://cdn.hoppercot.com/capone/page-banner/page-banner-desktop.jpeg",
      mobile:
        "https://cdn.hoppercot.com/capone/page-banner/page-banner-mobile.jpg",
    },
    cfar: {
      backgroundDesktop:
        "https://cdn.hoppercot.com/capone/cfar/cfar-background-desktop.jpeg",
      backgroundMobile:
        "https://cdn.hoppercot.com/capone/cfar/cfar-background-mobile.jpeg",
    },
    priceDropProtection: {
      desktop:
        "https://cdn.hoppercot.com/capone/price-drop-protection/price-drop-protection.jpeg",
      mobile:
        "https://cdn.hoppercot.com/capone/price-drop-protection/mobile-price-drop-protection.jpeg",
    },
    disruptionProtection: {
      background:
        "https://cdn.hoppercot.com/capone/disruption-protection/disruption-protection-background-mobile.jpeg",
    },
    priceWatch: {
      desktop:
        "https://cdn.hoppercot.com/capone/price-watch/b2b-price-watch-image.jpeg",
      mobile:
        "https://cdn.hoppercot.com/capone/price-watch/b2b-mobile-price-watch-image.jpeg",
    },
    priceFreeze: {
      desktop:
        "https://cdn.hoppercot.com/capone/price-freeze/price-freeze-desktop.jpeg",
      mobile:
        "https://cdn.hoppercot.com/capone/price-freeze/price-freeze-mobile.jpg",
    },
    priceMatch: {
      desktop:
        "https://cdn.hoppercot.com/capone/price-match/price-match-guarantee.jpeg",
      mobile:
        "https://cdn.hoppercot.com/capone/price-match/mobile-price-match-guarantee.jpeg",
    },
    trees: {
      confirmation:
        "https://cdn.hoppercot.com/capone/trees/trees-confirmation.jpeg",
    },
    hotels: {
      placeholder:
        "https://cdn.hoppercot.com/capone/hotels/lodging_placeholder.png",
    },
    premiumStays: {
      experienceCredit:
        "https://cdn.hoppercot.com/capone/premium-stays/experience-credit-desktop.jpg",
    },
    rewards: {
      cardArt: {
        ventureX:
          "https://cdn.hoppercot.com/capone/rewards/card_art/venture-x-card-art.webp",
        ventureXBusiness:
          "https://cdn.hoppercot.com/capone/rewards/card_art/venture-x-business-card-art.webp",
        venture:
          "https://cdn.hoppercot.com/capone/rewards/card_art/venture-card-art.webp",
        ventureBusiness:
          "https://cdn.hoppercot.com/capone/rewards/card_art/venture-business-card-art.webp",
        ventureOne:
          "https://cdn.hoppercot.com/capone/rewards/card_art/venture-one-card-art.webp",
        quicksilver:
          "https://cdn.hoppercot.com/capone/rewards/card_art/quicksilver-card-art.webp",
        savor:
          "https://cdn.hoppercot.com/capone/rewards/card_art/savor-card-art.webp",
        discoverIT:
          "https://cdn.hoppercot.com/capone/rewards/card_art/discover-it-card-art.webp",
        discoverChrome:
          "https://cdn.hoppercot.com/capone/rewards/card_art/discover-chrome-card-art.webp",
        discoverMiles:
          "https://cdn.hoppercot.com/capone/rewards/card_art/discover-miles-card-art.webp",
        discoverMore:
          "https://cdn.hoppercot.com/capone/rewards/card_art/discover-more-card-art.webp",
      },
      cardLogos: {
        VentureX:
          "https://cdn.hoppercot.com/capone/rewards/card-logos/venture-x-logo-light.webp",
        VentureXBusiness:
          "https://cdn.hoppercot.com/capone/rewards/card-logos/venture-x-business-logo-light.webp",
        Venture:
          "https://cdn.hoppercot.com/capone/rewards/card-logos/venture-logo-light.webp",
        VentureBusiness:
          "https://cdn.hoppercot.com/capone/rewards/card-logos/venture-logo-light.webp", // change when we have one
        VentureOne:
          "https://cdn.hoppercot.com/capone/rewards/card-logos/venture-one-logo-light.webp",
        Quicksilver:
          "https://cdn.hoppercot.com/capone/rewards/card-logos/quicksilver-logo-light.webp",
        Savor:
          "https://cdn.hoppercot.com/capone/rewards/card-logos/savor-logo-light.webp",
        DiscoverItCashBack:
          "https://cdn.hoppercot.com/capone/rewards/card-logos/discover-it-logo-light.svg",
        DiscoverItChrome:
          "https://cdn.hoppercot.com/capone/rewards/card-logos/discover-chrome-logo-light.svg",
        DiscoverItMiles:
          "https://cdn.hoppercot.com/capone/rewards/card-logos/discover-miles-logo-light.svg",
        DiscoverItMore:
          "https://cdn.hoppercot.com/capone/rewards/card-logos/discover-more-logo-light.svg",
      },
    },
  },
  caponeCorporate: {
    searchLoading: {
      flights:
        "https://cdn.hoppercot.com/capone-corporate/search-loading/corp-flights-search-loading.jpg",
      hotels:
        "https://cdn.hoppercot.com/capone-corporate/search-loading/hotels-search-loading_corp.jpg",
      cars: "https://cdn.hoppercot.com/capone-corporate/search-loading/cars-search-loading.jpg",
    },
    pageBanner:
      "https://cdn.hoppercot.com/capone-corporate/page-banner/page-banner.webp",
    signout: "https://cdn.hoppercot.com/capone-corporate/signout.png",
    priceMatch:
      "https://cdn.hoppercot.com/capone-corporate/price-match/corp-price-match-guarantee.png",
    cobtNotice: "https://cdn.hoppercot.com/capone-corporate/cobt_notice_image.png",
    aaBusinessLoyalty: {
      desktop:
        "https://cdn.hoppercot.com/capone-corporate/aa-business-loyalty/aa-business-loyalty-confirmation-desktop.jpg",
      mobile:
        "https://cdn.hoppercot.com/capone-corporate/aa-business-loyalty/aa-business-loyalty-confirmation-mobile.jpg",
    },
    rewards: {
      cardArt: {
        sparkCashPlus:
          "https://cdn.hoppercot.com/capone-corporate/rewards/card_art/spark-cash-plus-card-art.webp",
        sparkCash:
          "https://cdn.hoppercot.com/capone-corporate/rewards/card_art/spark-cash-card-art.webp",
      },
    },
  },
};
